var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("main-layout", [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("H1", { staticClass: "pageTitle isPoppins" }, [
          _vm._v("Order History")
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "top40 accSettingsForm",
            attrs: { id: "checkoutTableDiv" }
          },
          [
            _c(
              "table",
              { staticClass: "bottom10", attrs: { width: "100%" } },
              [
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.orders.length,
                        expression: "orders.length"
                      }
                    ],
                    staticClass: "top10 has-text-weight-bold"
                  },
                  [
                    _c(
                      "td",
                      {
                        staticClass: "has-text-warning",
                        attrs: { width: "10%" }
                      },
                      [_vm._v("Date")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "has-text-centered has-text-warning",
                        attrs: { width: "80%" }
                      },
                      [_vm._v("Invoice ID")]
                    ),
                    _vm._v(" "),
                    _c(
                      "td",
                      {
                        staticClass: "has-text-right has-text-warning",
                        attrs: { width: "20%" }
                      },
                      [_vm._v("Amount")]
                    )
                  ]
                ),
                _vm._v(" "),
                _vm._l(this.orders, function(order, index) {
                  return _c(
                    "tr",
                    {
                      key: order.id,
                      staticClass: "ordersRow",
                      class: { tableDarkRow: (index + 1) % 2 },
                      on: {
                        click: function($event) {
                          return _vm.doDetail(order.itemId)
                        }
                      }
                    },
                    [
                      _c("td", [
                        _vm._v(_vm._s(_vm.az.dateConvert(order.createDate)))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "has-text-centered" }, [
                        _vm._v(_vm._s(order.shortId))
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "has-text-right" }, [
                        _vm._v("$" + _vm._s(_vm.az.formatCurrency(order.price)))
                      ])
                    ]
                  )
                })
              ],
              2
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31aa1409", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31aa1409","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Orders.vue
// module id = null
// module chunks = 